export const PROJECTS_LIST_ROUTE = '/projects'
